import { render, staticRenderFns } from "./NotificationChannels.vue?vue&type=template&id=da158f50"
import script from "./NotificationChannels.vue?vue&type=script&lang=js"
export * from "./NotificationChannels.vue?vue&type=script&lang=js"
import style0 from "./NotificationChannels.vue?vue&type=style&index=0&id=da158f50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports